import React, { useRef, useState, useContext } from 'react';
import Button from '@carvana/showroom-forms/Button/Secondary';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { ImagePickerContainer, ReplaceButtonWrapper } from './styles';
import { eventableTypes } from '../../../constants';

const AddSvg = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="13"
      cy="13"
      r="11"
      fill="white"
      stroke="#00AED9"
      strokeWidth="2"
    />
    <path d="M13 9V17" stroke="#00AED9" strokeWidth="2" strokeLinecap="round" />
    <path
      d="M17 13L9 13"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

type ImagePickerProps = {
  onSelect: (file: File) => void;
  text?: string;
  testId?: string;
};

const ImagePicker = ({ onSelect, text = 'Add photo', testId = '' }: ImagePickerProps) => {
  const [selectedFile, setSelectedFile] = useState<string | null>(null);
  const { trackEvent } = useContext(AnalyticsContext);
  const ref = useRef<HTMLInputElement>(null);

  return (
    <ImagePickerContainer
      selectedFile={selectedFile}
      onClick={() => {
        // eslint-disable-next-line no-unused-expressions
        ref?.current?.click();
        trackEvent(eventableTypes.addPhoto);
      }}
      style={{ backgroundImage: `url(${selectedFile})` }}
    >
      {!selectedFile && (
        <>
          <AddSvg />
          <div>{text}</div>
        </>
      )}
      {selectedFile && (
        <ReplaceButtonWrapper>
          <Button size="small">
            Replace
          </Button>
        </ReplaceButtonWrapper>
      )}
      <input
        ref={ref}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        data-testid={testId}
        onChange={e => {
          if (e?.target?.files && e?.target?.files.length > 0) {
            setSelectedFile(URL.createObjectURL(e.target.files[0]));
            onSelect(e.target.files[0]);
          }
        }}
      />
    </ImagePickerContainer>
  );
};

export default ImagePicker;
